/*
 * pic-nn-web-ui
 *
 * Web UI for neural network applications.
 *
 * @copyright 2020 VSTE CB <http://www.vstecb.cz/>.
 * @license See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { bem } from "../shared/BEM";

/**
 * Component props
 */
export interface ISidebarPanelProps {
	/** If the panel should take all available height space */
	grow?: boolean;

	/** If to disable shrinking */
	disableShrink?: boolean;

	/** Contents */
	children: any;
}

/**
 * Sidebar panel component (wraps content with scroll when overflow)
 *
 * @param props Component props
 */
export function SidebarPanel(props: ISidebarPanelProps) {

	const modifiers = [];

	if (props.grow) {
		modifiers.push("grow");
	}

	if (props.disableShrink) {
		modifiers.push("disable-shrink");
	}

	const style = bem("sidebar-panel", "", modifiers);

	return <div className={style.className()}>
		{props.children}
	</div>;

}
